// Compact brand lockup (nav/sidebar/login). Wordmark is live text, not the
// stacked /iewrs-logo.png — that image's tagline turns to mush below ~44px.
// Assumes a light surface; dark surfaces use the full logo on a white card.
//
// The emblem is admin-overridable: BrandingContext serves an uploaded logo
// (Settings → Content → Branding) and we resolve override-first, falling
// back to the bundled /iewrs-emblem.png when none is set.
import { useBranding } from '../../contexts/BrandingContext'
import { resolveBranding } from '../../contexts/brandingLogic.mjs'

export default function BrandMark({
  iconClass = 'h-8',
  wordmarkClass = 'text-lg',
  wordmarkWrapClass = '',
  className = '',
}) {
  const { branding } = useBranding()
  const emblemSrc = resolveBranding(branding?.logo, '/iewrs-emblem.png?v=3')
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={emblemSrc}
        alt="IEWRS"
        width="512"
        height="512"
        className={`${iconClass} w-auto shrink-0 object-contain aspect-square`}
      />
      {/* aria-hidden: emblem's alt already announces the brand name */}
      <span
        aria-hidden="true"
        className={`font-bold tracking-tight leading-none ${wordmarkClass} ${wordmarkWrapClass}`}
      >
        <span className="text-brand-blue">IE</span><span className="text-brand-yellow">W</span><span className="text-brand-green">RS</span>
      </span>
    </span>
  )
}
